/* hl-responsive – Cookiebot-Symbol am Handy aus dem Weg nehmen (01.11.2026).
   Unter 1400 px (am Handy immer) verdeckt das schwebende Symbol unten links Text und Knöpfe (auch gleich oben, z. B. „Alle 33 Badheizkörper
   ansehen“ im Kopfbereich). Es ist deshalb am Handy ausgeblendet (Klasse html.hl-cookie-weg, CSS in hl-responsive.css 9)
   und erscheint, sobald man nach oben scrollt oder am Seitenende ist. Die Cookie-Einstellungen sind außerdem auf jeder
   Seite im Fuß erreichbar. */
(function () {
  'use strict';
  var schmal = window.matchMedia('(max-width: 1399px)');   // dort ist der Seitenrand schmaler als das Symbol
  var html = document.documentElement;
  var letztes = 0, tick = false;
  function y() {
    var pw = document.querySelector('.page-wrapper');
    return Math.max(window.scrollY || 0, pw ? pw.scrollTop : 0);
  }
  function hoehe() {
    var pw = document.querySelector('.page-wrapper');
    var s = document.scrollingElement || html;
    if (pw && pw.scrollHeight > pw.clientHeight + 5 && getComputedStyle(pw).overflowY === 'auto') return pw.scrollHeight - pw.clientHeight;
    return s.scrollHeight - window.innerHeight;
  }
  function pruefe() {
    tick = false;
    if (!schmal.matches) { html.classList.remove('hl-cookie-weg'); return; }
    var jetzt = y(), max = hoehe();
    var d = jetzt - letztes;                                                 // Richtung erst ab 24 px Weg werten
    if (jetzt >= max - 120) { html.classList.remove('hl-cookie-weg'); letztes = jetzt; }   // Seitenende: Fuß mit Platz darunter
    else if (d < -24) { html.classList.remove('hl-cookie-weg'); letztes = jetzt; }         // nach oben: zeigen
    else if (d > 24) { html.classList.add('hl-cookie-weg'); letztes = jetzt; }             // nach unten: aus dem Weg
  }
  function anfang() {
    if (!schmal.matches) return;
    letztes = y();
    html.classList.toggle('hl-cookie-weg', letztes < hoehe() - 120);
  }
  anfang();
  window.addEventListener('load', anfang);
  document.addEventListener('scroll', function () { if (!tick) { tick = true; requestAnimationFrame(pruefe); } }, { passive: true, capture: true });
})();
